export const HyperlinkType = {
  NO_REFERRER: 'noreferrer',
  NO_OPENER: 'noopener',
  EXTERNAL: 'external',
};

export const HyperlinkTarget = {
  SELF: '_self',
  BLANK: '_blank',
  PARENT: '_parent',
  TOP: '_top',
};
